import { PanelTitle } from "@shared/ui/PanelTitle";
import { Type } from "@shared/ui/Type";
import { Button } from "@shared/ui/Button";

type Props = {
  onStart: () => void;
};

export function OnboardingMatchingIntro({ onStart }: Props) {
  return (
    <PanelTitle
      title="Start Matching Survey"
      description="Pollinator will match you with five aligned peers based on your responses to this survey."
      isInverted
      className="flex-1"
    >
      <Type variant="body1" className="text-brand-100 text-center md:text-left">
        Note that we will never share your personal information without your
        consent.
      </Type>
      <Button
        variant="primary"
        theme="dark"
        className="size-max"
        onClick={onStart}
        data-testid="onboarding-matching-start"
      >
        Get Started
      </Button>
    </PanelTitle>
  );
}

export default OnboardingMatchingIntro;
